<template>
  <div class="content ">
    <h3 class="h3 mb20">{{ $t('lang.Card opening order details') }}</h3>
    <div>
      <p class="mb20">{{ $t('lang.Order number') }}{{ orderNo }}</p>
      <p class="mb20">
        <span class="mr20">{{ $t('lang.Card number') }}{{ tableData[0].cardNo }}</span>
        <span>{{ $t('lang.Order time') }}{{ $changeTime.showTime(rowData.createTime) }}</span>
      </p>
    </div>
    <h3 class="h3 mb20">{{ $t('lang.User Info') }}</h3>
    <el-table
      class="mb20"
      :data="tableData"
      style="width: 100%"
    >
      <el-table-column prop="unitName" :label="$t('lang.Organization')"></el-table-column>
      <el-table-column prop="surplusDays" :label="$t('lang.The remaining number of days')">
        <template slot-scope="{row}">
          {{ row.surplusDays || 0 }} {{ $t('lang.day') }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.Available times')">
        <template slot-scope="{row}">
          <div>
            {{ row.frequency || '--' }}
            <span v-if="row.frequency">{{ $t('lang.times') }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="date" :label="$t('lang.Effective time')">
        <template slot-scope="{row}">
          <!--生效时间范围不进行区分时区-->
          {{ $changeTime.showTime(Number(row.startTime), '', 0) }} -
          {{ $changeTime.showTime(Number(row.endTime), '', 0) }}
        </template>
      </el-table-column>
      <el-table-column prop="name" :label="$t('lang.Username')"></el-table-column>
      <el-table-column prop="contactInfo" :label="$t('lang.User contact')"></el-table-column>
    </el-table>
    <h3 class="h3 mb20">{{ $t('lang.Choose a package') }}</h3>
    <el-table
      class="mb20"
      :data="list"
      style="width: 100%"
    >
      <el-table-column prop="commodityNo" :label="$t('lang.Product number')"></el-table-column>
      <el-table-column prop="commdoityName" :label="$t('lang.Product name')"></el-table-column>
      <el-table-column prop="commodityTypeCode" :label="$t('lang.Product types')">
        <template slot-scope="{row}">
          {{ $t('lang.' + $changeObj(commodity_Type_Code)[row.commodityTypeCode]) }}
        </template>
      </el-table-column>
      <el-table-column prop="commodityTypeCode" :label="$t('lang.Product types')">
        <template slot-scope="{row}">
          <div v-if="row.commodityTypeCode == 15">{{ $t('lang.Measured card') }}</div>
          <div v-if="row.commodityTypeCode == 4">{{ $t('lang.Timer card') }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="quantity" :label="$t('lang.Amount of goods')"></el-table-column>
      <el-table-column prop="standerds" :label="$t('lang.Battery spec')"></el-table-column>
      <el-table-column :label="$t('lang.Available times')">
        <template slot-scope="{row}">
          <div>
            {{ row.frequency || '--' }}
            <span v-if="row.frequency">{{ $t('lang.times') }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.Effective time')">
        <template slot-scope="{row}">
          <div>
            {{ row.vaildDays || '--' }}
            <span v-if="row.vaildDays">{{ $t('lang.days') }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="price" :label="$t('lang.Battery unit price')">
        <template slot-scope="{row}">
          ฿{{ row.price || 0 }}
        </template>
      </el-table-column>
      <el-table-column prop="deposit" :label="$t('lang.Deposit')">
        <template slot-scope="{row}">
          ฿{{ row.deposit || 0 }}
        </template>
      </el-table-column>
      <el-table-column prop="totalAmount" :label="$t('lang.Total cost')">
        <template slot-scope="{row}">
          ฿{{ row.totalAmount || 0 }}
        </template>
      </el-table-column>
    </el-table>
    <el-button type="primary" @click="cancelBtn">{{ $t('lang.Cancel') }}</el-button>
  </div>
</template>

<script>
import {commodity_Type_Code} from '@/utils/constant'
import {thailandOrderManageDetail} from '@/api/orderManagement'

export default {
  data() {
    return {
      commodity_Type_Code,
      list: [],
      tableData: [],
      orderNo: '',
      rowData: {},
    }
  },
  mounted() {
    this.rowData = this.$route.query;
    console.log(this.rowData, 'this.rowData');
    this.orderNo = this.$route.query.orderNo;
    this.thailandOrderManageDetail();
  },
  methods: {
    cancelBtn() {
      this.$router.push('/managePage/chargeOrderMgmt');
    },
    async thailandOrderManageDetail() {
      const params = {
        orderNo: this.orderNo
      };
      try {
        const res = await thailandOrderManageDetail(params);
        this.tableData = [res.mdata.serviceOrderDetail];
        this.list = res.mdata.serviceOrderDetail.list;//套餐
      } catch (e) {
        console.log(e);
      }
    },
  },
  components: {}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/orderMgmt/batterySwapCardOrder.vue